import { ButtonLarge } from "../../../common/components/ui/buttons";
import { useState } from "react";
import { useTranslation } from "react-i18next";

type Props = {
  min: number;
  max: number;
  handleSubmit: (value: number) => void;
  step?: number;
};
export const Slider = ({ min, max, handleSubmit, step = 1 }: Props) => {
  const [value, setValue] = useState<number | null>(null);
  const { t } = useTranslation(["common"]);
  return (
    <div className="w-full flex flex-col gap-4">
      <div className="flex items-end justify-between w-full h-8">
        <p className="text-xs">{min}</p>
        <p className="text-heading-lg font-black text-green-100">{value}</p>
        <p className="text-xs">{max}</p>
      </div>
      <input
        type="range"
        min={min}
        max={max}
        step={step}
        value={value ?? Math.floor((min + max) / 2)}
        onChange={(event) => setValue(Number(event.target.value))}
        className="mb-4"
      />
      <ButtonLarge
        theme="goalCTA"
        disabled={value === null}
        onClick={() => value !== null && handleSubmit(value)}
      >
        {t(`submit`, { ns: "common" })}
      </ButtonLarge>
    </div>
  );
};
